// Contacts are intentionally NOT wired into the estimating module yet
// (contained mode — the owner will integrate Elite contacts later).
// These stubs keep the ported UI working with an empty contact list.

export async function listContacts() {
  return [];
}

export async function getContact() {
  return null;
}

export async function createContact() {
  throw new Error("Contacts aren't wired into the estimating module yet");
}

export async function updateContact() {
  throw new Error("Contacts aren't wired into the estimating module yet");
}
